module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "Images/f0008-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("North central and northeastern Missouri. Little Dixie extended from Callaway County on both sides of the Missouri River to Jackson County. "), _c('i', [_vm._v("Map by Colter Sikora")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "Images/f0009-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Western Missouri and eastern Kansas. The area affected by Order No. 11 was Jackson, Cass, Bates and the northern third of Vernon Counties. Most of Missouri’s slaves lived in “Little Dixie,” the counties along the Missouri River. "), _c('i', [_vm._v("Map by Colter Sikora")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c8a2308","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/fm01.vue
// module id = 72
// module chunks = 0